'use strict';
(function($){

	var $allowedDeliveryCountries = $('#allowed-delivery-countries');
	var $savePartnerSubmit = $('#save-partner-submit');
	var $form = $('#partner-form');
	var $categoryProducts = $('#category-products');

	$savePartnerSubmit.click(function(ev){
		ev.preventDefault();

		if($categoryProducts.length > 0){
			var $products = $categoryProducts.find('.products').find('div[product]');
			var data = [];
			$products.each(function(){
				data.push($(this).attr('product'));
			});
			$categoryProducts.find('#products-input').val(JSON.stringify(data));
		}

		$form.submit();
		return false;
	});

	if($categoryProducts.length > 0){
		var $productInputDatalist = $categoryProducts.find('#product-input-datalist');
		var $productInput = $categoryProducts.find('#product-input');

		$categoryProducts.find('#product-add').click(function(){
			var product = $productInput.val();
			// if(! /(["\$#\*]+)/.test(product) ){
			// 	alert('Invalid product name');
			// 	return false;
			// }
			if($productInput.length > 0 && product != ''){
				var $products = $categoryProducts.find('.products');
				$('<div product="'+product+'">'+product+'</div>').prependTo($products);
				$productInputDatalist.find('option[value="'+product+'"]').remove();
				$productInput.val('');
			}
		});

		$(document).on('click', '#category-products .products > div[product]', function(){
			var product = $(this).attr('product');
			$('<option value="'+product+'">'+product+'</option>').prependTo($productInputDatalist);
			$(this).remove();
		});

		var $productsInput = $categoryProducts.find('#products-input');
		if($productsInput.length > 0 && $productsInput.val() != ''){
			try{
				var products = JSON.parse($productsInput.val());
			}catch(err){
				console.error(err);
				return;
			}
			if(Array.isArray(products)){
				var $products = $categoryProducts.find('.products');
				products.forEach(function(product){
					$('<div product="'+product+'">'+product+'</div>').prependTo($products);
					$productInputDatalist.find('option[value="'+product+'"]').remove();
				});
			}
		}
	}

	if($allowedDeliveryCountries.length > 0){
		var $allowedCountriesInput = $allowedDeliveryCountries.find('#allowed-countries-input');
		var $availableCountries = $allowedDeliveryCountries.find('.available-countries');
		var $allowedCountries = $allowedDeliveryCountries.find('.allowed-countries');

		$(document).on('click', '#allowed-delivery-countries .available-countries > div[code]', function(){
			$(this).clone().prependTo($allowedCountries);
			$(this).remove();
			$allowedCountries.scrollTop(0);
			updateCountriesList();
			$allowedCountries.find('.worldwide').hide();
		});

		$(document).on('click', '#allowed-delivery-countries  .allowed-countries > div[code]', function(){
			$(this).clone().prependTo($availableCountries);
			$(this).remove();
			$availableCountries.scrollTop(0);
			updateCountriesList();
			if($allowedCountries.find('div[code]').length < 1){
				$allowedCountries.find('.worldwide').show();
			}
		});

		if($allowedCountriesInput.length > 0 && $allowedCountriesInput.val() != ''){
			try{
				var allowedCountries = JSON.parse($allowedCountriesInput.val());
			}catch(err){
				console.error(err);
				return;
			}
			if(Array.isArray(allowedCountries)){
				allowedCountries.forEach(function(allowedCountry){
					$availableCountries.find('[code="' + allowedCountry + '"]').trigger('click');
				});
			}
		}
	}

	var $searchCountry = $allowedDeliveryCountries.find('#country-search');

	$searchCountry.keyup(function(ev){
		var searchText = $(this).val();
		var $availableCountries = $allowedDeliveryCountries.find('.available-countries');
		var $countries = $availableCountries.find('[code]');
		$countries.each(function(){
			if( $(this).text().toLowerCase().indexOf(searchText) > -1 || searchText == '') {
				$(this).show();
			}else{
				$(this).hide();
			}
		});
	})

	function updateCountriesList(){
		var $countries = $allowedCountries.find('div[code]');
		var data = [];
		$countries.each(function(){
			data.push($(this).attr('code'));
		});
		$allowedCountriesInput.val(JSON.stringify(data));
	}

}(jQuery));
